import { IApplicationState } from '../../types/redux';
import { getFilters } from './getFilters';

export function getMinPrice(state: IApplicationState) {
  const filters = getFilters(state);

  return filters.minPrice;
}

export function getMaxPrice(state: IApplicationState) {
  const filters = getFilters(state);

  return filters.maxPrice;
}
